// extracted by mini-css-extract-plugin
export default {"container":"kjjqDoZM-+","name":"Opgz6PqvRw","image":"KIf9j-9CU5","info":"JGCFrtBhhB","info-item":"a9OchedLwG","infoItem":"a9OchedLwG","description":"a-W5z-00R-","links":"VnKzYcXVXS"};